import { render, staticRenderFns } from "./TrangCaNhan.vue?vue&type=template&id=2d22c2a5&scoped=true"
import script from "./TrangCaNhan.vue?vue&type=script&lang=ts"
export * from "./TrangCaNhan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22c2a5",
  null
  
)

export default component.exports